import Blur from 'features/blur/blur';

export interface VisitorTileData {
  label: string;
  count: number | string;
  metric: string | number;
}

export const VisitorNumberTile = ({
  tileData: { label, count, metric }
}: {
  tileData: VisitorTileData;
}) => {
  let metricMessage = '';
  const shouldShowConvertedMetric = metric > 0 || metric < 0;
  const convertedMetric = metric.toLocaleString('en-GB', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  });

  if (metric > 0) {
    metricMessage = convertedMetric + '% higher than average';
  } else if (metric < 0) {
    metricMessage = convertedMetric.replace('-', '') + '% lower than average';
  }
  return (
    <>
      <div className="px-3 py-2" key={label}>
        <div className="flex items-center justify-between">
          <div>
            <header className="text-neutral-500 text-md leading-7 mb-1">
              {label}
            </header>
            <Blur>
              <p className="font-bold text-black text-3xl leading-8">{count}</p>
            </Blur>
          </div>
          {shouldShowConvertedMetric ? (
            <Blur>
              <div
                className={`${
                  convertedMetric.includes('-')
                    ? 'text-error-300'
                    : 'text-tertiary-600'
                } shrink bg-neutral-150 whitespace-pre py-0.5 px-2 -mt-10 rounded text-xs`}
              >
                <span>{convertedMetric.includes('-') ? '-' : '+'}</span>
                <span>&nbsp;</span>
                <span>{convertedMetric.replace('-', '')}%</span>
              </div>
            </Blur>
          ) : null}
        </div>

        <div className="text-neutral-500 text-sm mt-25">{metricMessage}</div>
      </div>
    </>
  );
};
